import React from 'react';
import ReactDOM from 'react-dom';
import App from './client/App';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <App
    wizardPage={ document.getElementById('root').getAttribute('wizardPage') }
    bin_page={ document.getElementById('root').getAttribute('bin_page') }
    profile={ document.getElementById('root').getAttribute('profile') }
  />,
  document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js